import { render, staticRenderFns } from "./DocText.vue?vue&type=template&id=b6b29672&"
import script from "./DocText.vue?vue&type=script&lang=js&"
export * from "./DocText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports